/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:14
 * @Description: 过滤器入口
 */

// demo，可删除
import { arg } from "./arg";
export const registerFilters = (Vue) => {
	// 这里注册你的全局过滤器
	arg(Vue);
};
